import { Component } from '@angular/core';

@Component({
  selector: 'icon-no-cover',
  standalone: true,
  template: `
    <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.5" y="0.5" width="47" height="47" rx="7.5" fill="#F2F2F2" stroke="#1C6E70"/>
        <path d="M30 38.8369C28.1471 39.5869 26.1218 40 24 40C15.1634 40 8 32.8367 8 24C8 15.1633 15.1634 8 24 8C26.1218 8 28.1471 8.41309 30 9.16309V18.7085C28.5341 17.0476 26.3894 16 24 16C19.5817 16 16 19.5818 16 24C16 28.4182 19.5817 32 24 32C26.3894 32 28.5341 30.9524 30 29.2915V38.8369Z" fill="#0C8080"/>
        <path d="M32 37.8596C36.7824 35.0933 40 29.9224 40 24C40 23.3228 39.9579 22.6553 39.8762 22H32V37.8596Z" fill="#2A4B5A"/>
        <path d="M39.4959 19.9998C38.4141 15.7964 35.6671 12.2615 32 10.1401V19.9998H39.4959Z" fill="#11B7B7"/>
    </svg>
  `
})

export class NoCoverIconComponent {

}
